import React, { useEffect, useState } from 'react';
import { useTermItemsQuery } from '../../../graphql/graphql';
import useTranslation from '../../../Hooks/useTranslation';
import Loading from '../../../Components/Loading';
import RadioList, {
	RadioListItem,
} from '../../../Components/Form/components/RadioList';

interface Props {
	termType: string;
	onChange?: (value: RadioListItem) => void;
	inLine?: boolean;
}

const TermItemRadioList: React.FC<Props> = ({
	termType,
	onChange,
	inLine = false,
}) => {
	const [options, setOptions] = useState<RadioListItem[]>([]);
	const { data, isLoading } = useTermItemsQuery({ termType: termType });
	const termItems = data?.termItems;
	const { t } = useTranslation();

	useEffect(() => {
		const items: RadioListItem[] = [];
		for (const termItem of termItems?.data || []) {
			if (termItem) {
				items.push({
					title: t(termItem.name ?? '') ?? termItem.id,
					value: termItem.id,
				});
			}
		}

		setOptions(items);
	}, [termItems]);

	if (isLoading) {
		return <Loading />;
	}

	return <RadioList data={options} onChange={onChange} inLine={inLine} />;
};
export default TermItemRadioList;
